'use client'

import { useState } from 'react'
import { CardElement } from '@stripe/react-stripe-js'
import { useStripeElementTheme } from '@/hooks/useStripeElementTheme'

type Props = {
  onCompleteChange?: (complete: boolean) => void
}

export function PaymentCard({ onCompleteChange }: Props) {
  const stripeTheme = useStripeElementTheme()
  const [cardComplete, setCardComplete] = useState(false)

  return (
    <div
      className="border rounded-lg p-3"
      style={{ background: stripeTheme.bg }}
    >
      <CardElement
        key={stripeTheme.key}
        onChange={(e) => {
          setCardComplete(e.complete)
          onCompleteChange?.(e.complete)
        }}
        options={stripeTheme.options}
      />
    </div>
  )
}